

let tlite = function(selector, children) {
	let nodelist = !(children) ? document.querySelectorAll(selector) : children.querySelectorAll(':scope ' + selector);
	let liteObj = Object.create(tlite.prototype);
	nodelist.forEach((val, index) => {liteObj[index] = val});

	if (Object.entries(liteObj).length) {
		return liteObj;
	} else {
		return tlite_blank;
	}

}

let tt = function(selector, children) {
	let object = (!children) ? document.querySelectorAll(selector)[0] : children.querySelectorAll(':scope ' + selector)[0];
	
	if (object) {
		return object;
	} else {
		return tlite_blank;
	}
}

//console.log(`${index} : ${val}`)


// keeping all funtions here

let tfunctions = {

	each: function(callback) {
		for (val of Object.values(this)) {
			callback(val);
		}

	},

	addClass: function(classes) {
		irit(this, this.addClass, classes);

		let element = this;
	
		if (!element.className) {element.className = classes; return}
	
		element.className += ` ${classes}`;		
	},
	
	removeClass: function(classes) {
		irit(this, this.removeClass, classes);

		let element = this;
	
		if (!element.className || !classes) return;
	
		classes = classes.split(" ");
		let cl_string = new Set(element.className.split(" "));
		
		classes.forEach((el) => {cl_string.delete(el)});
		element.className = [...cl_string].join(" "); 
	},

	css: function(prop) {
		if (this.constructor.name == "tlite") {
			this.each((val) => {this.css.call(val, prop)});
			return;
		}

		prop = prop.split(":");
		if (prop.length < 2) {
			if (!prop[0].length) {return}
			
			return this.style[`${prop[0]}`];
		} else {
			this.style[`${prop[0]}`] = prop[1];
		}
	},

	attr: function(atr, val) {
		let element
		element = this;

		if (val) {
			element.setAttribute(atr, val);
		} else {
			return element.getAttribute(atr);
		}
	},

	parent: function(classes) {
		if (this.constructor.name == "tlite") {
			let parent_arr = []
			this.each((val) => {parent_arr.push(this.parent.call(val))});
			let liteObj = Object.create(tlite.prototype);
			parent_arr.forEach((val, index) => {liteObj[index] = val});
			return liteObj;
		}

		irit(this, this.parent);
		let element = this;
		return this.parentElement;
	},

	siblings: function(selector) {
		if (this.constructor.name == "tlite") {

		}	

		let child_arr = [...this.parentElement.children].filter((el) => el != this);

		if (selector) {
			let matched_selector = Object.values(t(selector, this.parentElement));
			matched_selector.filter((el) => {
				return child_arr.includes(el);
			})
			child_arr = matched_selector;
		}
		let liteObj = Object.create(tlite.prototype); 
		child_arr.forEach((val, index) => {liteObj[index] = val});
		return liteObj;
	},

	child: function(selector) {
		if (this.constructor.name == "tlite") {
			let children_arr = []
			this.each((val) => {children_arr.push(Object.values(this.child.call(val, selector)))});
			let liteObj = Object.create(tlite.prototype);
			children_arr.flat().forEach((val, index) => {liteObj[index] = val});
			return liteObj;
		}

		let element
		element = this;

		if (!selector) {
			return element.children[0]
		} else if (selector == '@all') {
			t("div", element);
		} else {
			return t(selector, element);
		}

	},

	listen: function(event, callback) {
		if (this.constructor.name == "tlite") {
			this.each((val) => {this.listen.call(val,...arguments)});
			return;
		}

		let element
		element = this;
		element.addEventListener(event, callback);
	},

	notListen: function(event, name) {
		if (this.constructor.name == "tlite") {
			this.each((val) => {this.notListen.call(val,...arguments)});
			return;
		}

		this.removeEventListener(event, name);
	},

	// Handle adding animations with classes and pass a callback fnctoin on animation end.
	animate: function(name, callback, reverse) {
		if (this.constructor.name == "tlite") {
			this.each((val) => {this.animate.call(val, name, callback, reverse)});
			return;
		}

		if (name.includes("animated")) {
			let callback_1 = function() {
				//this.removeClass(name); 
				this.removeEventListener('animationend', callback_1);
				if (callback) {
					callback();
				}
			}
			this.listen('animationend', callback_1);
		} else {
			let callback_1 = function() {
				this.removeEventListener('transitionend', callback_1);
				callback();	
			}	
			this.listen('transitionend', callback_1);
		}

		if (reverse == "reverse") {
			this.removeClass(name);
		} else {
			this.addClass(name);
		}
	},

	hasClass: function(name) {
		return this.classList.contains(name);
	},

	mkEle: function(htmlString) {
  		var div = document.createElement('div');
  		div.innerHTML = htmlString.trim();
  		return div.firstChild;
	}

}



// loop trough t funtions and add them to tlite.prototype and HTMLElement.prototype

for ([key, val] of Object.entries(tfunctions)) {
	tlite.prototype[key] = val;
	HTMLElement.prototype[key] = val;
}

// Make blank object with placeholder names for functions to handle errors

// Iterate tlite object nodes when method is chained to it
let tlite_blank = Object.create(tlite.prototype);;
for ([key, val] of Object.entries(tfunctions)) {
	if (key == 'mkEle') {
		tlite_blank[key] = val;
	} else {
		tlite_blank[key] = function() {return undefined};
	}
}

let irit = function(lite_ele, func, optional) {
	if (lite_ele.constructor.name == "tlite") {
			lite_ele.each((val) => {func.call(val, optional)});
			return;
		}
}

// Get element full string name with id's, classes and other attributes



let t = tlite;